<template>
  <el-dialog
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="報告書商品明細別進捗管理一覧（植栽）"
    top="5vh"
    width="900px"
    :visible.sync="dialogVisible"
    append-to-body
    class="el_dialog"
    @close="close"
  >
    <vab-form ref="form" :model="formObject" :rules="rulesDay">
      <div class="flex_space margin_bottom_7 flex_align_end">
        <div class="flex_center_align">
          <div class="split_line"></div>
          <div class="box_title">PS課処理</div>
        </div>
        <vab-button :btn-list="btnListRt" />
      </div>

      <div class="sure_box top_info mtn">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">
            <div>報告書到着日</div>
          </vab-col>
          <vab-col :span="20" class="word_box word_box_690 word_box_imp">
            <div class="flex_center_align">
              <vab-date-picker
                class="vab_picker margin_0"
                type="date"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                prop="reportArrivaiDate"
              />
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">
            <div>不具合報告欄チェック（アピール加点）</div>
          </vab-col>
          <vab-col :span="20" class="word_box word_box_690 nopadding">
            <vab-row>
              <vab-col :span="24" class="word_box word_box_imp">
                <div class="flex_center_align">
                  <!-- prop="defectCommentFlag"	prop="commenrPhotoFlag" -->
                  <vab-checkbox
                    label="不具合コメントあり"
                    :nullable="true"
                    class="margin_0"
                  />
                  <vab-checkbox
                    label="写真あり"
                    :nullable="true"
                    class="margin_0 margin_left_16"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col
                :span="24"
                class="word_box word_box_imp"
                style="border: none"
              >
                <div class="flex_start">
                  <span
                    class="clo_right_span textarea_span flex_center flex_align"
                  >
                    メモ
                  </span>
                  <vab-textarea
                    type="textarea"
                    prop="comment"
                    rows="5"
                    class="vab_textarea clo_textarea margin_0"
                  />
                </div>
              </vab-col>
            </vab-row>
          </vab-col>
        </vab-row>
      </div>
      <div style="margin: 17px 0 7px 0" class="flex_center_align">
        <div class="split_line"></div>
        <span class="box_title">作業情報</span>
      </div>
      <div class="sure_box top_info mtn">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">作業名称</vab-col>
          <vab-col :span="8" class="flex_center_align word_box word_box_265">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.wrknm }}</div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">発注No連番</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.acceptOrderNoSeq }}
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.blgsnmkj }}
              </div>
              <div class="sub_title">（建物CD：{{ formObject.blgscd }}）</div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">所属部門</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.orgkj }}</div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">協力会社</vab-col>
          <vab-col
            :span="20"
            class="word_box word_box_690 word_box_imp flex_center_align"
          >
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.bcnfrkj }}</div>
              <div class="sub_title">
                （協力会社CD：{{ formObject.hcccd }}）
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">作業予定日</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.wpdtmin }} ~ {{ formObject.wrkendpltm }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">作業実施日</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.wxdtmin }} ~ {{ formObject.wrkendtm }}
              </div>
            </div>
          </vab-col>
        </vab-row>
      </div>
    </vab-form>
    <div slot="footer" class="dialog-footer flex_end mg12">
      <div class="flex_start flex_center_align">
        <div class="cancel" @click="close">キャンセル</div>
        <vab-button :btn-list="btnList" />
      </div>
    </div>
    <PopupChildren
      :visible2="visibleChildren"
      :list="popChildrenList"
      :visible-children.sync="visibleChildren"
    />
  </el-dialog>
</template>

<script>
  export default {
    name: 'ReportPopupPlanting',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formObject: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        btnListRt: [
          {
            name: ' 各種データダウンロード',
            widht: 'auto',
            icon: 'select',
            type: 'plain',
            hover: '#0071EE',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000446.name}`
            ),
            defaultColor: '#0060C2',
            hidden: false,
            click: () => {
              this.show()
            },
          },
        ],
        visibleChildren: false,
        dialogVisible: false,
        rulesDay: {},
        open: '2',
        columns: [
          {
            label: '氏名',
            'min-width': 228,
            prop: '',
          },
          {
            label: 'FM社員CD',
            'min-width': 120,
            prop: '',
          },
          {
            label: '職種名称',
            'min-width': 228,
            prop: '',
          },
          {
            label: '休日パターン',
            'min-width': 160,
            prop: '',
          },
          {
            label: '勤務時間',
            'min-width': 120,
            prop: '',
          },
        ],
        btnList: [
          {
            name: '更新',
            icon: 'answer',
            type: 'button',
            hidden: false,
            click: (row) => {
              console.log('???', row)
              // this.submitForm(row)
            },
          },
        ],
        value: '',
        options: [
          {
            value: '选项1',
            label: '黄金糕',
          },
          {
            value: '选项2',
            label: '双皮奶',
          },
        ],

        popChildrenList: [
          {
            buttonList: [
              {
                name: ' トラ送付状',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' box到着分送付状',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' 植栽一覧',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
        ],
      }
    },

    watch: {
      visible: function (val) {
        this.dialogVisible = val
      },
    },
    methods: {
      show() {
        this.visibleChildren = true
      },
      close() {
        this.dialogVisible = false
        this.$emit('update:visibleDay', false)
      },
    },
  }
</script>

<style lang="scss" scoped>
  * {
    line-height: 150%;
  }
  .row_box {
    .vab_picker ::v-deep .el-input {
      width: 140px;
    }

    .vab_picker ::v-deep .el-form-item--mini.el-form-item {
      display: flex !important;
    }

    .clo_right_span {
      color: #000000;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      width: 70px;
      margin-right: 34px;
    }

    .clo_textarea {
      width: 628px;
      margin: 0;
    }

    .textarea_span {
      margin-right: 10px;
      width: 28px;
      height: 21px;
    }
  }
  .el_dialog {
    ::v-deep .el-dialog__title {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: #003350;
    }
    ::v-deep .el-dialog__header {
      padding: 12px;
    }
    ::v-deep .el-dialog__body {
      padding: 24px;
    }
    ::v-deep .el-dialog__headerbtn {
      top: 12px;
      font-size: 24px;
    }
  }

  .split_line {
    width: 4px;
    height: 20px;
    background: #003350;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .box_title {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #003350;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin-left: 8px;
  }
  .margin_bottom_7 {
    margin-bottom: 7px;
  }

  .title_box {
    width: 160px;
  }

  .word_box_690 {
    width: 690px;
  }
  .word_box_imp {
    padding: 8px 12px !important;
  }
  .word_box_265 {
    width: 265px;
    padding: 8px 12px !important;
  }
  .flex_align_end {
    align-items: flex-end;
  }
  .margin_0 {
    margin: 0 !important;
  }
  .margin_left_16 {
    margin-left: 16px !important;
  }
</style>
